import React from 'react';
import { Settings, Mail } from 'lucide-react';
export function Footer() {
  return <footer className="bg-slate-950 py-10 border-t border-slate-800" data-id="element-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-17">
        <div className="flex flex-col items-center gap-3 mb-6" data-id="element-18">
          <div className="w-12 h-12 rounded-full bg-brand-green/15 text-brand-green flex items-center justify-center" data-id="element-19">
            <Settings size={24} data-id="element-20" />
          </div>
          <a href="mailto:EbookDreamShop@gmail.com" className="inline-flex items-center gap-2 text-white/80 hover:text-brand-green transition-colors text-sm font-medium" data-id="element-21">
            <Mail size={16} data-id="element-22" />
            EbookDreamShop@gmail.com
          </a>
          <p className="text-slate-500 text-xs" data-id="element-23">
            ¿Necesitás ayuda? Escribinos.
          </p>
        </div>

        <p className="text-slate-500 text-sm" data-id="element-24">
          © {new Date().getFullYear()} Triatlón en 6HS. Todos los derechos
          reservados.
        </p>
        <p className="text-slate-600 text-xs mt-2" data-id="element-25">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
      </div>
    </footer>;
}